<template>
    <v-app>
        <v-main class="main-bg">

            <!-- HERO / BANNER -->
            <section class="fill-height bg-4 d-flex align-center">
                <v-container >
                    <div class="d-flex justify-center position-relative logo-circle">
                        <img src="@/assets/passport-banner/live-album-logo-circle.png" height="120" alt="">
                    </div>
                    <div class="d-flex justify-center mt-neg-40 position-relative">
                        <div class="border-gold border-radius-15 pa-10 bg-white w-100 max-w-800">
                            <div class="text-center">
                                <h2 class="text-blue font-facifico">{{ details.user?.name }}</h2>
                                <div class="text-gold mt-1">Event Participant</div>
                            </div>
                            <div class="text-box border-blue border-radius-10 text-blue pa-2 mt-2">
                                <v-icon>mdi-account</v-icon> {{ details.user?.name }}
                            </div>
                            <div class="text-box border-blue border-radius-10 text-blue pa-2 mt-2">
                                <v-icon>mdi-email-outline</v-icon> {{ details.user?.email }}
                            </div>
                            <div class="text-box border-blue border-radius-10 text-blue pa-2 mt-2">
                                <v-icon>mdi-phone-in-talk</v-icon> {{ details.user?.mobile }}
                            </div>
                            <div class="text-box border-blue border-radius-10 text-blue pa-2 mt-2">
                                <v-icon>mdi-map-marker</v-icon> {{ details.user?.city }}
                            </div>
                            <template v-if="details?.attended_at">
                                <div class="text-box border-blue border-radius-10 text-blue pa-2 mt-2">
                                    <v-icon>mdi-calendar</v-icon> Attended last {{ details?.attended_at }}
                                </div>
                            </template>
                            <!-- <template v-else>
                                <v-btn large block class="mt-4 darken-4" color="primary" @click="confirmAttendance()">Confirm Attendance</v-btn>
                            </template> -->
                        </div>
                    </div>
                </v-container>
            </section>
        </v-main>
    </v-app>
</template>
<script>
import api from '@/services/axios';
import { utilsMixin } from '@/composables/utils';
import Header from '../components/Header.vue';
export default {
    name: "PassportJourneyLanding",
    mixins: [utilsMixin],
    components: { Header },
    data() {
        return {
            modal: false,
            errorsDialog: false,
            successDialog: false,
            errors: [],
            currentStep: 1,
            eventCategoryOptions: {},
            form: {
                basicInfo: false,
                eventDetails: false,
                consent: false,
            },
            details: {
                category: null,
                biggest_challenge: "Budgeting",
                registering_as: null,
                source: 'Other',
                event: {
                    date: null,
                    needs: [],
                }
            }
        };
    },
    mounted() {
        let code = this.$route.params.code;
        api.get(`/event-attendance/${code}`).then(res => {
            this.details = res.data;
        });
    },
    methods: {
        async confirmAttendance() {
            if(confirm('Are you sure?')) {
               try {
                const response = await api.post(`/event-attendance/${this.details.registration_code}`);

                this.details = response.data;
               } catch (error) {
                
               }
            }
        }
    },
};
</script>

<style scoped>
.main-title {
    color: #1a3765;
}

/* HERO */
.hero-section {
    position: relative;
    overflow: hidden;
    background-image: url("@/assets/passport-banner/banner.png");
    background-size: fixed;
    background-position: top center;
}

.hero-overlay {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.7);
    /* black with 50% opacity */
}

.hero-content {
    position: relative;
    z-index: 2;
}

.hero-title {
    font-size: 58px;
    line-height: 1.1;
    font-weight: 800;
    color: #1a3765;
}

.text-blue {
    color: #1a3765;
}

.hero-subtitle {
    font-size: 18px;
    line-height: 1.8;
    max-width: 560px;
}

.font-facifico {
    font-family: 'Pacifico', cursive;
}

.font-dm-serif {
    font-family: 'DM Serif Display', serif;
}

.live-album-logo {
    padding: 15px;
}

.circle {
    border-radius: 50%;
}

.border-gold {
    border: 2px solid #a47803;
}

.border-radius-15 {
    border-radius: 15px;
}

.mt-neg-40 {
    margin-top: -40px;
}

.text-gold {
    color: #a47803;
}

.textbox {
    padding: 5px;
}

.border-radius-10 {
    border-radius: 10px;
}

.border-blue {
    border: 1px solid #1a3765;
}

.bg-white {
    background-color: #fff;
}

.v-main {
    background-color: #fdf1d3;
}
.bg-4 {
    background-repeat: no-repeat;
    background-image: url('@/assets/passport-banner/banner4.png');
    background-position: top center;
}
.max-w-800 {
    max-width: 800px;
}
.w-100 {
    width: 100%;
}
.position-relative {
    position: relative;
}

.logo-circle {
    z-index: 100;
}


@media (max-width: 768px) {
    .bg-4 {
        background-repeat: no-repeat;
        background-image: url('@/assets/passport-banner/banner.png');
        background-position: top right;
    }

    .stepper-wrapper {
        gap: 0px;
    }
}
</style>